import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import config from '../configs'

export default createVuetify({
  theme: {
    defaultTheme: config.theme.globalTheme,
    themes: {
      dark: { colors: config.theme.dark },
      light: { colors: config.theme.light }
    }
  }
})
